import ProtocolContent from "../../components/layouts/tentang/ProtocolContent";

import React from "react";

const Protokol: React.FC = () => {
  return <ProtocolContent />;
};

export default Protokol;
